import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";
import { toast } from "sonner";

export interface Garantia {
  id: number;
  descricao?: string;
  diasGarantia: number;
  textoImpressao?: string | null;
  isInativo: boolean;
}

export interface GarantiaFormData {
  descricao?: string;
  diasGarantia: number;
  textoImpressao?: string | null;
  isInativo?: boolean;
}

export function useGarantias() {
  const queryClient = useQueryClient();

  const { data: garantias = [], isLoading } = useQuery({
    queryKey: ["garantias"],
    queryFn: async () => (await apiClient.get<Garantia[]>("/api/tipos-garantia")).data,
  });

  const createGarantia = useMutation({
    mutationFn: async (formData: GarantiaFormData) => (await apiClient.post<Garantia>("/api/tipos-garantia", formData)).data,
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: ["garantias"] }); toast.success("Garantia criada com sucesso!"); },
    onError: (error: Error) => toast.error("Erro ao criar garantia: " + error.message),
  });

  const updateGarantia = useMutation({
    mutationFn: async ({ id, ...formData }: GarantiaFormData & { id: number }) =>
      (await apiClient.put<Garantia>(`/api/tipos-garantia/${id}`, formData)).data,
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: ["garantias"] }); toast.success("Garantia atualizada com sucesso!"); },
    onError: (error: Error) => toast.error("Erro ao atualizar garantia: " + error.message),
  });

  const deleteGarantia = useMutation({
    mutationFn: async (id: number) => { await apiClient.delete(`/api/tipos-garantia/${id}`); },
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: ["garantias"] }); toast.success("Garantia excluída com sucesso!"); },
    onError: (error: Error) => toast.error("Erro ao excluir garantia: " + error.message),
  });

  return { garantias, isLoading, createGarantia, updateGarantia, deleteGarantia };
}
